import { wktToGeoJSON } from '@terraformer/wkt';

import type { TLatLng } from './types';

/*
- в экосистеме форматов WKT/GeoJSON принят порядок координат "lng, lat"
- при отображении на картах - наоборот "lat, lng"
- при парсинге wkt сразу приводим к "карточному" формату "lat, lng"
*/
export function wktToLatLng(wkt?: string | null): TLatLng[] {
  if (!wkt) return [];
  try {
    const geojson = wktToGeoJSON(wkt);
    if (geojson?.type !== 'Polygon') return [];
    const ring = (geojson.coordinates?.[0] ?? []) as [number, number][];
    return ring.slice(0, -1).map(([x, y]) => [y, x]);
  } catch {
    return [];
  }
}
